.highlight {
  background-color: var(--color-bg-critical-a-subtle);
}
